import {
    Button,
    Card,
    Checkbox,
    Col,
    Form,
    Input,
    message,
    Modal,
    Row,
    Select,
    Table,
    Tabs,
} from "antd";
import { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import Layout from "../../Components/Layout/Layout";
import AlphaSlider from "../../Components/Sliders/AlphaSlider/AlphaSlider";
import axios from "../../config/axios";
import styles from "./ReturnRefunds.module.scss";

const ReturnRefunds = () => {
    const slider_1 = [
        {
            img: "https://desi-fresh.b-cdn.net/components_static/Account/refund_slider_1.svg",
            url: "/",
        },
        {
            img: "https://desi-fresh.b-cdn.net/components_static/Account/refund_slider_1.svg",
            url: "/",
        },
        {
            img: "https://desi-fresh.b-cdn.net/components_static/Account/refund_slider_1.svg",
            url: "/",
        },
    ];
    const [activeKey, setActiveKey] = useState("1");
    return (
        <Layout>
            <div className="container">
                {window.innerWidth < 991 ? (
                    <div className={styles.breadcrumb}>
                        <BreadCrumb
                            list={[
                                { name: "Home", link: "/" },
                                {
                                    name: "Return & Refunds",
                                    link: "/return-refunds",
                                },
                            ]}
                        />
                    </div>
                ) : (
                    <div className={styles.breadcrumb}>
                        <BreadCrumb
                            list={[
                                { name: "Back to Home", link: "/" },
                                {
                                    name: "Returns and complaints",
                                    link: "/return-refunds",
                                },
                                {
                                    name: "Returns and complaints",
                                    link: "/return-refunds",
                                },
                                {
                                    name:
                                        activeKey === "1"
                                            ? "Return Instructions"
                                            : activeKey === "2"
                                            ? "Make your return label"
                                            : "Return Status",
                                    link: "/return-refunds",
                                },
                            ]}
                        />
                    </div>
                )}

                {window.innerWidth < 991 ? (
                    <AlphaSlider slides={slider_1} dt_slides={slider_1} />
                ) : (
                    <img
                        src="https://desi-fresh.b-cdn.net/components_static/return_refund_dektop.svg"
                        alt="return"
                        width={"100%"}
                    />
                )}

                {/* tab content */}
                <div className={styles.ret_ref_tab}>
                    <div className="custom_return_tab">
                        <Tabs
                            defaultActiveKey="1"
                            tabPosition="top"
                            animated={{
                                inkBar: true,
                                tabPane: true,
                            }}
                            onChange={(key) => {
                                setActiveKey(key);
                            }}
                        >
                            <Tabs.TabPane tab="Return Instructions" key="1">
                                <ReturnInstruction />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab="Make your return label" key="2">
                                <MakeReturnLabel />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab="Return Status" key="3">
                                <ReturnStatus />
                            </Tabs.TabPane>
                        </Tabs>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default ReturnRefunds;

const ReturnInstruction = () => {
    const [modalVisible, setModalVisible] = useState(false);
    function showModal() {
        setModalVisible(true);
    }

    function hideModal() {
        setModalVisible(false);
    }
    return (
        <div className={styles.return_instruction}>
            <h2 className={styles.return_instruction_title}>
                Returns and Refunds
            </h2>
            <p className={styles.return_instruction_subtitle}>
                When Dr. Preeti, the founder and CEO of Desi Fresh came to
                Germany as an immigrant, she was thoroughly disappointed with
                the desi grocery shopping experience. Grocery stores, even
                specialty stores like Aldi and Lidl etc, offered little to no
                Desi products, and the levels of hygiene and cleanliness at the
                exclusive indian and asian stores were not satisfactory
                whatsoever. As a Food Science professional with more than 16
                years of experience in food quality, food safety and
                traceability, and packaging, she knew that something had to be
                done.
            </p>

            {window.innerWidth < 991 ? (
                <>
                    <h2 className={styles.return_instruction_title}>
                        Store Returns
                    </h2>
                    <img
                        src="https://desi-fresh.b-cdn.net/components_static/Account/store_refund_top.svg"
                        alt="refund_top"
                        className={styles.ret_ins_img}
                    />
                </>
            ) : (
                <img
                    src="https://desi-fresh.b-cdn.net/components_static/store-returns_desktop.svg"
                    alt="refund_top"
                    style={{
                        marginBottom: 30,
                    }}
                />
            )}

            {window.innerWidth < 991 ? (
                <img
                    src="https://desi-fresh.b-cdn.net/components_static/Account/store_returns_bottom.svg"
                    alt="return_bottom"
                    className={styles.ret_ins_img}
                    style={{ marginBottom: 30 }}
                />
            ) : (
                <img
                    src="https://desi-fresh.b-cdn.net/components_static/postal-returns.svg"
                    alt="return_bottom"
                    style={{ marginBottom: 30 }}
                />
            )}

            <img
                src="https://desi-fresh.b-cdn.net/components_static/Account/ret_ref_video.svg"
                alt="ret_ref_video"
                className={styles.ret_ins_video}
                onClick={showModal}
            />

            <VideoModal visible={modalVisible} onCancel={hideModal} />

            <div className={styles.language_sel}>
                <Select
                    defaultValue="en"
                    style={{ width: 120, marginBottom: 20 }}
                    options={[
                        { label: "English", value: "en" },
                        { label: "German", value: "de" },
                    ]}
                />
            </div>

            <LikeDislike />
        </div>
    );
};

const MakeReturnLabel = () => {
    const [selectedBoxType, setSelectedBoxType] = useState("square");
    const [orders, setOrders] = useState([]);
    const [orderItems, setOrderItems] = useState([]);
    const [selectedOrderItems, setSelectedOrderItems] = useState([]);

    useEffect(() => {
        (async () => {
            const res = await axios.get("/orders/filter/users", {
                withCredentials: true,
            });
            setOrders(res.data);
        })();
    }, []);

    // make options for select box
    const orderOptions = orders?.map((order) => ({
        label: `Order #${order.id}`,
        value: order.id,
    }));

    const boxTypes = [
        {
            type: "square",
            label: "Square Box",
            image: "https://desi-fresh.b-cdn.net/components_static/square_box.svg",
        },
        {
            type: "rectangular",
            label: "Rectangular Box",
            image: "https://desi-fresh.b-cdn.net/components_static/rectangular_box.svg",
        },
        {
            type: "bag",
            label: "Bag",
            image: "https://desi-fresh.b-cdn.net/components_static/bag.svg",
        },
    ];

    const columns = [
        {
            title: "Product Name",
            dataIndex: "title",
        },
        {
            title: "Quantity",
            dataIndex: "quantity",
            render: (quantity) => (
                <Select
                    defaultValue={quantity}
                    style={{ width: 60 }}
                    options={Array.from({ length: quantity }, (_, i) => ({
                        label: i + 1,
                        value: i + 1,
                    }))}
                />
            ),
        },
        {
            title: "Price",
            dataIndex: "order_time_price",
            render: (price) => <span>{price} €</span>,
        },
    ];

    // rowSelection object indicates the need for row selection
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            console.log(
                `selectedRowKeys: ${selectedRowKeys}`,
                "selectedRows: ",
                selectedRows
            );
        },
    };

    return (
        <div className={styles.make_return_label}>
            <h2 className={styles.return_label_title}>
                Make your return label
            </h2>
            <p className={styles.return_instruction_subtitle}>
                When Dr. Preeti, the founder and CEO of Desi Fresh came to
                Germany as an immigrant, she was thoroughly disappointed with
                the desi grocery shopping experience. Grocery stores, even
                specialty stores like Aldi and Lidl etc, offered little to no
                Desi products, and the levels of hygiene and cleanliness at the
                exclusive indian and asian stores were not satisfactory
                whatsoever. As a Food Science professional with more than 16
                years of experience in food quality, food safety and
                traceability, and packaging, she knew that something had to be
                done.
            </p>

            <Row gutter={[10, 10]}>
                {boxTypes.map((boxType, index) => (
                    <Col span={8} key={index}>
                        <Card
                            className={styles.box_type_wrap}
                            bodyStyle={{ padding: 5 }}
                            onClick={() => setSelectedBoxType(boxType.type)}
                        >
                            <img
                                src={
                                    selectedBoxType === boxType.type
                                        ? "https://desi-fresh.b-cdn.net/components_static/radio_selected.svg"
                                        : "https://desi-fresh.b-cdn.net/components_static/radio.svg"
                                }
                                alt="radio"
                                style={{ marginBottom: 5 }}
                            />

                            <p className={styles.box_type_label}>
                                {" "}
                                {boxType.label}{" "}
                            </p>

                            <img src={boxType.image} alt="box_image" />
                        </Card>
                    </Col>
                ))}
            </Row>

            <Row>
                <Col span={24}>
                    <div style={{ marginTop: 20 }}>Order Number*</div>
                    <Select
                        showSearch
                        placeholder="Select your order number"
                        optionFilterProp="children"
                        onChange={(value) => {
                            setOrderItems(
                                orders.find((order) => order.id === value)
                                    .order_items
                            );
                            setSelectedOrderItems([]);
                        }}
                        style={{ width: "100%", marginBottom: 20 }}
                        filterOption={(input, option) =>
                            (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                        options={orderOptions}
                    />
                </Col>

                <Col span={24}>
                    <div>Item/s to be returned *</div>
                    <Select
                        showSearch
                        placeholder="Select your order items"
                        optionFilterProp="children"
                        style={{ width: "100%", marginBottom: 20 }}
                        filterOption={(input, option) =>
                            (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                        options={orderItems?.map((orderItem) => ({
                            label: `${orderItem.id} - ${orderItem.title}`,
                            value: orderItem.id,
                        }))}
                        onChange={(value) => {
                            // set selected order items in state and remove duplicates if any
                            setSelectedOrderItems([
                                ...new Set([...selectedOrderItems, value]),
                            ]);
                        }}
                    />
                </Col>

                <Col span={24}>
                    <Table
                        rowSelection={{
                            ...rowSelection,
                        }}
                        columns={columns}
                        dataSource={selectedOrderItems.map(
                            (selectedOrderItem) => {
                                const orderItem = orderItems?.find(
                                    (orderItem) =>
                                        orderItem.id === selectedOrderItem
                                );
                                return {
                                    key: orderItem.id,
                                    title: orderItem.title,
                                    quantity: orderItem.quantity,
                                    order_time_price:
                                        orderItem.order_time_price,
                                };
                            }
                        )}
                        pagination={false}
                        className="selected_order_items_table"
                    />
                </Col>

                <Col span={24}>
                    <div style={{ marginTop: 20 }}>Search By Address</div>
                    <Select
                        showSearch
                        placeholder="Select destination address"
                        optionFilterProp="children"
                        onChange={(value) => {
                            console.log(value);
                        }}
                        style={{ width: "100%", marginBottom: 20 }}
                        filterOption={(input, option) =>
                            (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                        options={[]}
                    />
                </Col>

                <Col span={24}>
                    <img
                        style={{ width: "100%" }}
                        src="https://desi-fresh.b-cdn.net/components_static/demo_map.png"
                        alt="map"
                    />
                </Col>

                <Col span={24}>
                    <div className={styles.submit_print_btn}>
                        <Button
                            type="primary"
                            onClick={() =>
                                message.success("Return label created")
                            }
                        >
                            Submit & Print Return Label
                        </Button>
                    </div>
                </Col>
            </Row>
            <LikeDislike />
        </div>
    );
};

const ReturnStatus = () => {
    const delivery_partners = [
        {
            image: "https://desi-fresh.b-cdn.net/components_static/hermes_logo.svg",
        },
        {
            image: "https://desi-fresh.b-cdn.net/components_static/ups_logo.svg",
        },
        {
            image: "https://desi-fresh.b-cdn.net/components_static/dhl_logo.svg",
        },
        {
            image: "https://desi-fresh.b-cdn.net/components_static/dpd_logo.svg",
        },
    ];

    const TrackOrder = (values) => {
        if (!values.order_number || !values.order_number.length) {
            message.error("Please enter order number");
            return;
        }
        console.log(values);
    };

    return (
        <div className={styles.return_status}>
            <h2 className={styles.return_label_title}>Return Status</h2>
            <p className={styles.return_instruction_subtitle}>
                We are sorry to hear that the item (s) from your order
                #1572711957 were not suitable for you. Please allow up to 15 -20
                days from returning your order to credit a refund into your
                account. The credit or debit card or bank account of the
                customer who placed the order will received the refund in the
                account. For store returns, cash will be directly received at
                the desk. Please check the{" "}
                <Link to="/return-policy">return policy</Link> for detailed
                description. In order to return the order, follow the simple
                steps listed below
            </p>

            <Button type="primary" block>
                Track Return reciept Nr.
            </Button>

            <Form
                layout="vertical"
                name="return_status_form"
                initialValues={{ remember: true }}
                onFinish={TrackOrder}
                style={{ marginTop: 20, width: "100%" }}
            >
                <Row>
                    <Col span={24}>
                        <Form.Item label="Order Number*" name="order_number">
                            <Input placeholder="Enter your order number" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="remember"
                            valuePropName="checked"
                            noStyle
                        >
                            <Checkbox>Remember me</Checkbox>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                color: "var(--color-primary)",
                                textDecoration: "underline",
                            }}
                        >
                            <Link to={"/forgot-receipt"}>
                                Forgot the reciept Nr.
                            </Link>
                        </div>
                    </Col>

                    <Col span={24}>
                        <Form.Item>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: 20,
                                }}
                            >
                                <Button type="primary" htmlType="submit">
                                    Track the refund
                                </Button>
                            </div>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

            <h4 style={{ fontWeight: "600" }}>
                If it is outside Munich Area, please click your chosen delivery
                partner
            </h4>

            <Row>
                {delivery_partners.map((delivery_partener, index) => (
                    <Col span={6} key={index}>
                        <img
                            src={delivery_partener.image}
                            alt="delivery_partener"
                            style={{ width: "100%", height: 25 }}
                        />
                    </Col>
                ))}
            </Row>

            <br />

            <LikeDislike />
        </div>
    );
};

const LikeDislike = () => {
    return (
        <>
            <div className={styles.question}>
                <img
                    src="https://desi-fresh.b-cdn.net/components_static/Account/ret-ref-question.svg"
                    alt="ret-ref-question"
                />
                <h4>Was that helpful?</h4>
            </div>
            <div className={styles.like_dislike}>
                <img
                    src="https://desi-fresh.b-cdn.net/components_static/Account/Like.svg"
                    onClick={() =>
                        message.success("Thank you for your feedback")
                    }
                    alt="Like"
                />
                <img
                    src="https://desi-fresh.b-cdn.net/components_static/Account/Dislike.svg"
                    alt="Dislike"
                    onClick={() =>
                        message.success("Thank you for your feedback")
                    }
                />
            </div>
        </>
    );
};

const VideoModal = ({ visible, onCancel }) => {
    return (
        <Modal
            open={visible}
            onCancel={onCancel}
            footer={null}
            destroyOnClose
            closable={null}
            bodyStyle={{ padding: 0 }}
            centered
            width={window.innerWidth > 991 ? "60%" : "100%"}
        >
            <div
                style={{
                    position: "relative",
                    paddingBottom: "56.25%" /* 16:9 */,
                }}
            >
                <ReactPlayer
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                    }}
                    url="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
                    width="100%"
                    height="100%"
                    muted={true}
                    playing={true}
                    controls={true}
                />
            </div>
        </Modal>
    );
};
